import { jsx as _jsx } from "react/jsx-runtime";
import { Box, CircularProgress } from '@mui/material';
import styles from 'components/common/Spinner.module.scss';
export const Spinner = () => (_jsx(Box, { className: styles.spinner, children: _jsx(CircularProgress, {}) }));
